/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/reset_medium'
export default icon
